export default __webpack_public_path__ + "static/typing@2x-cf86ef7699f3fd08a64e3e58cbb31adc.png";